export enum EfcBrand {
  TOYOTA = 'TOY',
  LEXUS = 'LEX',
}

export const EFC_IMG_DOMAIN = 'https://next.ws.tms.aws.toyota.com';
